export default __webpack_public_path__ + "static/media/DNo.22-4.a0cd12c0.jpg";